module.exports = __webpack_public_path__ + "img/remove-disabled.bbb69463.svg";